import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-35XRF6560N";

/** Sends a pageview to Google Analytics on every client-side route change. */
export default function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("config", GA_ID, {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}
